export enum PackageType {
    Free = 1,
    Small = 2,
    Medium = 3,
    Large = 4,
    ExtraLarge = 5,
    XXL = 6,
}

export const PackageTypes: IPackageType[] = [
    { Id: PackageType.Free, TextId: 'package_type.free' },
    { Id: PackageType.Small, TextId: 'common.small' },
    { Id: PackageType.Medium, TextId: 'common.medium' },
    { Id: PackageType.Large, TextId: 'common.large' },
    { Id: PackageType.ExtraLarge, TextId: 'package_type.extra_large' },
    { Id: PackageType.XXL, TextId: 'package_type.xxl' },
];

export interface IPackageType {
    Id: PackageType;
    TextId: string;
}

export interface IPackageTypeMap {
    [p: string]: IPackageType;
    [p: number]: IPackageType;
}
